<app-action-window></app-action-window>
<app-notification-bar></app-notification-bar>
<div class="d-block d-lg-flex content">
  <app-dashboard-header (click)="onClick($event)"></app-dashboard-header>
  <div class="container-fluid content-container">
    <div class="toolbar-sticky-wrapper d-none d-lg-inline-block">
      <div class="menu-container toolbar-container">
        <app-toolbar-menu [isAdmin$]="isAdmin$"></app-toolbar-menu>
      </div>
    </div>
    <div class="inner-content position-relative pb-5" (click)="onClick($event)">
      <app-progress-bar class="d-none d-lg-block"></app-progress-bar>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
